import React, { FC } from "react";
import { Message } from "semantic-ui-react";

const RefundUnavailable: FC = () => (
  <div style={{ padding: "32px" }}>
    <Message warning>
      <Message.Header>Refunds are temporarily unavailable</Message.Header>
      <p>
        The refund admin UI has been disabled while it's being rebuilt. If you
        need to issue a refund, contact engineering.
      </p>
    </Message>
  </div>
);

export default RefundUnavailable;
